import * as React from 'react'
import { cn } from '../../lib/utils'

export interface StepperProps extends React.HTMLAttributes<HTMLDivElement> {
	current: number
	total: number
	label?: string
}

const Stepper = React.forwardRef<HTMLDivElement, StepperProps>(
	({ className, current, total, label, ...props }, ref) => (
		<div
			ref={ref}
			className={cn('flex flex-col gap-2 w-full', className)}
			{...props}
		>
			<p className="text-sm font-normal leading-5 text-(--color-muted-foreground)">
				{label ?? `Шаг ${current} из ${total}`}
			</p>
			<div className="flex gap-1 items-center">
				{Array.from({ length: total }, (_, i) => (
					<div
						key={i}
						className={cn(
							'w-[68px] h-2 rounded-full',
							i < current
								? 'bg-(--color-brand)'
								: 'bg-(--color-secondary)',
						)}
					/>
				))}
			</div>
		</div>
	),
)
Stepper.displayName = 'Stepper'

export { Stepper }
